// startup
// Load entry module
__webpack_require__("./resources/js/src/entry-client.js");
// This entry module used 'exports' so it can't be inlined
